
import { Component, Prop, Vue } from "vue-property-decorator";
import { BIconTriangleFill } from "bootstrap-vue";

@Component({ components: { BIconTriangleFill } })
export default class AccordionItem extends Vue {
  @Prop({ default: "titulo" }) title: string;
  @Prop({ default: 1 }) itemNumber: number;
}
